import type { BuildTimeEnvironment } from '@core/config/app-config.types';

export const environment: BuildTimeEnvironment = {
  production: false,
  runtimeConfigUrl: '/config/app-config.json',
  includeDevShellRoutes: true,
};
